import gql from 'graphql-tag'

export const ADD_CONTACT = gql`
 mutation insert_contacts($email: String!,$id: uuid!,$mobile: bigint!,$name: String!,$role: Int!, $clientid: uuid!) {
  insert_contacts(objects: {email: $email, id: $id, mobile: $mobile, name: $name, role: $role, clientid: $clientid}) {
    returning {
      id
 }
}
  }
`

export const ADD_CONTACT_TO_ADDRESSBOOK = gql`
 mutation insert_addressbookedcontacts($email: String!,$id: uuid!,$mobile: bigint!,$name: String!,$role: Int!, $clientid: uuid!) {
  insert_addressbookedcontacts(objects: {email: $email, id: $id, mobile: $mobile, name: $name, role: $role, clientid: $clientid}) {
    returning {
      id
 }
}
  }
`
export const ADD_COMPANY_USER = gql`
 mutation insert_CompanyUser($object: [CompnayUser_insert_input!]!) {
  insert_CompnayUser(objects: $object) {
    returning {
      id
 }
}
  }
`
